import { render, staticRenderFns } from "./SecurityPage.vue?vue&type=template&id=35d37046&scoped=true&lang=pug&"
import script from "./SecurityPage.vue?vue&type=script&lang=ts&"
export * from "./SecurityPage.vue?vue&type=script&lang=ts&"
import style0 from "./SecurityPage.vue?vue&type=style&index=0&id=35d37046&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d37046",
  null
  
)

export default component.exports